import React, { Fragment, useState } from 'react';
import { Card, Tabs } from 'antd';
import InvoiceHistory from './InvoiceHistory';
import DebtHistory from './DebtHistory';

const { TabPane } = Tabs;

export default ({ customer, reload }) => {

	const [currentTab, setCurrentTab] = useState('1');

	return <Fragment>
		<Card className={'mt-20'}>
			<Tabs defaultActiveKey={currentTab} onChange={t => setCurrentTab(t)}>
				<TabPane tab="Lịch sử mua hàng" key="1">
					<InvoiceHistory />
				</TabPane>
				<TabPane tab="Công nợ" key="2">
					<DebtHistory reload={reload} />
				</TabPane>
			</Tabs>
		</Card>
	</Fragment>;
}
